import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiAccordion } from '@taiga-ui/experimental';
import { TuiBlock, TuiSkeleton } from '@taiga-ui/kit';
import { environment } from '../../../../environments/environment';
import { Router, RouterOutlet } from '@angular/router';
import { ROUTES_CONST } from '../../../const/menu';
import { TuiAppearance, TuiButton, TuiGroup, TuiIcon } from '@taiga-ui/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-learning',
  standalone: true,
  imports: [
    CommonModule,
    TuiAccordion,
    TuiSkeleton,
    TuiAppearance,
    TuiButton,
    ReactiveFormsModule,
    TuiBlock,
    TuiGroup,
    RouterOutlet,
    TranslocoDirective,
  ],
  templateUrl: './learning.component.html',
  styleUrls: ['./learning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LearningComponent {
  protected readonly router = inject(Router);
  private readonly translocoService = inject(TranslocoService);
  skeleton = true;
  skeletonBerne = true;
  environment = environment;
  ROUTES_CONST = ROUTES_CONST;
  protected readonly formRoute = new FormGroup({
    page: new FormControl(ROUTES_CONST.PARENT_LEARN),
  });

  ngOnInit(): void {
    if (location.pathname.search(ROUTES_CONST.PARENT_LEARN) !== -1) {
      this.formRoute.get('page')?.setValue(ROUTES_CONST.PARENT_LEARN);
    }

    if (location.pathname.search(ROUTES_CONST.ADULT_LEARN) !== -1) {
      this.formRoute.get('page')?.setValue(ROUTES_CONST.ADULT_LEARN);
    }

    if (location.pathname.search(ROUTES_CONST.CHILD_LEARN) !== -1) {
      this.formRoute.get('page')?.setValue(ROUTES_CONST.CHILD_LEARN);
    }

    this.formRoute.get('page')?.valueChanges.subscribe((value) => {
      if (
        value === ROUTES_CONST.PARENT_LEARN ||
        value === ROUTES_CONST.ADULT_LEARN ||
        value === ROUTES_CONST.CHILD_LEARN
      ) {
        this.router.navigate([
          `/${ROUTES_CONST.TRAINING}/${ROUTES_CONST.LEARNING}/${value}`,
        ]);
      }
    });
  }
}
